import { CrewMember } from '../types';
import { RNG } from '../utils/RNG';
import { uid } from '../utils/helpers';

const FIRST_NAMES = [
  'Elena', 'Marcus', 'Yuki', 'Rashid', 'Sofia', 'James',
  'Amara', 'Diego', 'Ingrid', 'Chen', 'Fatima', 'Oliver',
  'Priya', 'Kofi', 'Lena', 'Tomás', 'Anya', 'Bjorn',
  'Mei', 'Hassan', 'Clara', 'Dmitri', 'Zara', 'Kwame',
];

const LAST_NAMES = [
  'Santos', 'Okafor', 'Petrov', 'Nakamura', 'Hansen', 'Al-Rashid',
  'Chen', 'Müller', 'Torres', 'Johansson', 'Patel', 'Kim',
  'Dubois', 'Kowalski', 'Tanaka', 'Singh', 'Ferreira', 'Ivanov',
  'Nguyen', 'Berg', 'Osei', 'Larsson', 'Morales', 'Ahmad',
];

export class CrewManager {
  crew: CrewMember[] = [];

  generateCandidates(rng: RNG): CrewMember[] {
    const count = rng.range(3, 5);
    const candidates: CrewMember[] = [];

    for (let i = 0; i < count; i++) {
      const firstName = rng.pick(FIRST_NAMES);
      const lastName = rng.pick(LAST_NAMES);
      const skill = rng.range(1, 5);
      const wage = skill * 100 + rng.range(0, 50);

      candidates.push({
        id: uid(),
        name: `${firstName} ${lastName}`,
        skill,
        wage,
        active: true,
      });
    }

    return candidates;
  }

  hire(member: CrewMember): void {
    this.crew.push({ ...member, active: true });
  }

  fire(memberId: string): void {
    this.crew = this.crew.filter((m) => m.id !== memberId);
  }

  getDailyWages(): number {
    return this.crew
      .filter((m) => m.active)
      .reduce((sum, m) => sum + m.wage, 0);
  }

  getActiveCount(): number {
    return this.crew.filter((m) => m.active).length;
  }

  toggleActive(memberId: string): void {
    const member = this.crew.find((m) => m.id === memberId);
    if (member) {
      member.active = !member.active;
    }
  }

  getDigCapacity(): number {
    return this.crew
      .filter((m) => m.active)
      .reduce((sum, m) => sum + m.skill, 0);
  }
}
